export default __webpack_public_path__ + "static/media/Camion5-t.abeb7b67.png";